import { Button, DesignType } from '@/components/atoms/Button';
import { Image } from '$components/basic/Image';
import { PreloadImage } from '$util/PreloadImage';
import Styled from './styled';

const carParkSrc = '/car-park/car-parking-lot_facmuo.jpg';

export default function TopSection() {
  return (
    <Styled className="TopSection">
      <PreloadImage provider="cloudinary" src={carParkSrc} />
      <Image provider="cloudinary" src={carParkSrc} alt="car park" layout="fill" objectFit="cover" />
      <div>
        <h1>Parking Price Index</h1>
        <Button type="submit" designType={DesignType.PRIMARY} size="L">
          <a target="_self" href="#ParkingCosts">
            <strong>VIEW STATS</strong>
          </a>
        </Button>
      </div>
    </Styled>
  );
}
